import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Dragger from "./Dragger";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxHeight: "80%",
  overflowY: "auto",
  bgcolor: "#F8EEDB",
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
};

export const uploadDocs = [
  {
    category: "invoices",
    id: Date.now(),
    subCategory: [
      {
        name: "sales",
        listName: ["goods", "services", "assets"],
      },
      {
        name: "Income",
        listName: ["goods", "services", "assets"],
      },
      {
        name: "Purchase",
        listName: ["goods", "services", "assets"],
      },
      {
        name: "Credit Note",
        listName: ["Credit note"],
      },
      {
        name: "Debit Notes",
        listName: ["Debit Note"],
      },
      {
        name: "Expenses",
        listName: ["Operating", "Financing", "Investment"],
      },
      {
        name: "Capital",
        listName: ["Capital"],
      },
      {
        name: "ZipFiles",
        listName: ["ZipFiles"],
      },
    ],
  },
  {
    category: "Upload Bank Statement",
    id: Date.now(),
    subCategory: [
      {
        name: "Saving Account",
        listName: ["Bank Statement"],
      },
      {
        name: "Current Account",
        listName: ["Bank Statement"],
      },
      {
        name: "Currency Account",
        listName: ["Bank Statement"],
      },
    ],
  },
  {
    category: "otherDocs",
    id: Date.now(),
    subCategory: [
      {
        name: "Docs",
        listName: ["Docs"],
      },
    ],
  },
  {
    category: "Reports",
    id: Date.now(),
    subCategory: [
      {
        name: "Finance",
        listName: ["Balance", "Profit Loss", "Cash Flow"],
      },
      {
        name: "Admin",
        listName: [
          "User Management",
          "Content Management",
          "Analytics and Reporting",
          "System Health and Monitoring",
        ],
      },
      {
        name: "HR",
        listName: [
          "Employee Performance Dashboard",
          "Recruitment Dashboard",
          "Employee Engagement Dashboard",
        ],
      },
      {
        name: "MIS",
        listName: ["Docs"],
      },
      {
        name: "Marketing",
        listName: ["Docs"],
      },
    ],
  },
];

const UploadModel = ({ open, handleClose, category, subCategory, kycId, onFileUpload }) => {
 

  const renderInvoiceDraggers = () => {
    const invoiceTypes = uploadDocs.find(doc => doc.category.toLowerCase() === 'invoices')
      .subCategory.find(sub => sub.name.toLowerCase() === subCategory.toLowerCase())?.listName || [];

    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {invoiceTypes.map(type => (
          <Dragger key={type} category={category} subCategory={subCategory} fileType={type} kycId={kycId} onFileUpload={onFileUpload} />
        ))}
      </div>
    );
  };

  const renderBankStatementDraggers = () => {
    const statementTypes = ['monthly', 'yearly', 'quarterly', 'weekly'];

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h4>{subCategory}</h4>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {statementTypes.map(statementType => (
            <Dragger
              key={`${subCategory}-${statementType}`}
              category={category}
              subCategory={subCategory}
              fileType={statementType}
              kycId={kycId}
              onFileUpload={onFileUpload}
            />
          ))}
        </div>
      </div>
    );
  };

  const renderOtherDocsDraggers = () => (
    <Dragger category={category} subCategory={subCategory} fileType="docs" kycId={kycId} onFileUpload={onFileUpload} />
  );

  const renderReportDraggers = () => {
    const reportTypes = uploadDocs.find(doc => doc.category.toLowerCase() === 'reports')
      .subCategory.find(sub => sub.name.toLowerCase() === subCategory.toLowerCase())?.listName || [];

    return (
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between" }}>
        {reportTypes.map(type => (
          <Dragger
            key={type}
            category={category}
            subCategory={subCategory}
            fileType={type}
            kycId={kycId}
            onFileUpload={onFileUpload}
          />
        ))}
      </div>
    );
  };

  const renderDraggers = () => {
    
    switch (category.toLowerCase()) {
      case 'invoices':
        return renderInvoiceDraggers();
      case 'upload bank statement':
        return renderBankStatementDraggers();
      case 'other docs':
        return renderOtherDocsDraggers();
      case 'reports':
        return renderReportDraggers();
      default:
      
        return null;
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <div style={{ position: "relative" }}>
          <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
            Upload Files for {subCategory}
          </h3>
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "20px",
            }}
          >
            &times;
          </button>
        </div>

        {renderDraggers()}

        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Box>
    </Modal>
  );
};

export default UploadModel;
